// import {
//     Layout,
//     Menu,
//     Avatar,
//     Button,
//     Dropdown,
//     Space,
//     Badge,
// } from "antd";
// import {
//     BellOutlined,
//     DownloadOutlined,
//     UserOutlined,
// } from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";
// import { MenuList } from "./nav/MenuList";
// import HeaderBar from "./HeaderBar";
// // import brand_logo from '../../assets/brand_logo.png'
// import brand_logo from '../../assets/brand_logo.png'

// const { Header } = Layout;

// export default function TopHeader({ activeParent, setActiveParent }) {
//     const navigate = useNavigate();

//     const parentItems = MenuList.map(item => ({
//         key: item.key,
//         icon: item.icon,
//         label: item.label,
//     }));

//     const onParentClick = ({ key }) => {
//         const parent = MenuList.find(i => i.key === key);
//         if (!parent) return;

//         setActiveParent(parent);

//         if (parent.children && parent.children.length > 0) {
//             navigate(parent.children[0].to);
//         }
//         else if (parent.to) {
//             navigate(parent.to);
//         }
//     };


//     const profileMenu = (
//         <Menu
//             items={[
//                 { key: "profile", label: "Profile" },
//                 { key: "settings", label: "Settings" },
//                 {
//                     key: "logout",
//                     label: "Logout",
//                     danger: true,
//                     onClick: () => {
//                         localStorage.clear();
//                         window.location.reload();
//                     },
//                 },
//             ]}
//         />
//     );

//     return (
//         <Header
//             style={{
//                 background: "#fff",
//                 display: "flex",
//                 alignItems: "center",
//                 padding: "44px",
//                 height: 64,
//                 position: "sticky",
//                 top: 0,
//                 zIndex: 100,
//                 boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
//             }}
//         >

//             {/* Logo - Right Corner */}
//             <div
//                 style={{
//                     display: "flex",
//                     alignItems: "center",
//                     marginLeft: 40,
//                 }}
//             >
//                 <img
//                     src={brand_logo}
//                     alt="Brand Logo"
//                     style={{
//                         height: 60,
//                         width: "auto",
//                         objectFit: "contain",
//                     }}
//                 />
//             </div>


//             {/* Parent Menu - Centered */}
//             <Menu
//                 mode="horizontal"
//                 items={parentItems}
//                 selectedKeys={[activeParent?.key]}
//                 onClick={onParentClick}
//                 style={{ flex: 1, borderBottom: "none", justifyContent: "center" }}
//             />

//             <HeaderBar />


//         </Header>
//     );
// }
import { Layout, Menu } from "antd";
import { useNavigate } from "react-router-dom";
import { MenuList } from "./nav/MenuList";
import HeaderBar from "./HeaderBar";
import brand_logo from "../../assets/brand_logo.png";
import { filterMenuByPermission } from "../utils/filterMenuByPermission";

const { Header } = Layout;

export default function TopHeader({ activeParent, setActiveParent }) {
  const navigate = useNavigate();

  const visibleMenuList = filterMenuByPermission(MenuList);

  const parentItems = visibleMenuList.map((item) => ({
    key: item.key,
    icon: item.icon,
    label: item.label,
  }));

  const onParentClick = ({ key }) => {
    const parent = visibleMenuList.find((i) => i.key === key);
    if (!parent) return;

    setActiveParent(parent);

    if (parent.children && parent.children.length > 0) {
      navigate(parent.children[0].to);
    } else if (parent.to) {
      navigate(parent.to);
    }
  };

  return (
    <Header
      style={{
        background: "#f6f8fb",
        padding: "12px 20px",
        height: "auto",
        lineHeight: "normal",
        position: "sticky",
        top: 0,
        zIndex: 100,
        borderBottom: "1px solid #e8edf4",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          minHeight: 72,
          borderRadius: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 18px",
          boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
          border: "1px solid #eef2f7",
          gap: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            minWidth: 180,
            flexShrink: 0,
          }}
        >
          <img
            src={brand_logo}
            alt="Brand Logo"
            style={{
              height: 48,
              width: "auto",
              objectFit: "contain",
              display: "block",
            }}
          />
        </div>

        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            minWidth: 0,
          }}
        >
          <Menu
            mode="horizontal"
            items={parentItems}
            selectedKeys={[activeParent?.key]}
            onClick={onParentClick}
            style={{
              borderBottom: "none",
              background: "transparent",
              minWidth: 0,
              width: "100%",
              maxWidth: 1100,
              justifyContent: "center",
              fontWeight: 500,
            }}
            overflowedIndicator={<span style={{ fontWeight: 600 }}>More</span>}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            minWidth: 180,
            flexShrink: 0,
          }}
        >
          <HeaderBar />
        </div>
      </div>
    </Header>
  );
}